// extracted by mini-css-extract-plugin
export default {"container":"container-1-p6t","soon":"soon-3w-C9"};